module.exports = __webpack_public_path__ + "static/img/function-4.9594058.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-4.png
// module id = Pkl3
// module chunks = 0